import { RootState } from "index";
import { useSelector } from "react-redux";

const useHasPermission = () => {
  const user: any = useSelector((state: RootState) => state?.Login?.user);

  const hasPermission = (permission: string): boolean => {
    return user?.permissions?.includes(permission) ?? false;
  };

  return hasPermission;
};

export default useHasPermission;
